import { render, staticRenderFns } from "./studentExam_desktop.vue?vue&type=template&id=7db7696d&scoped=true&"
import script from "./studentExam_desktop.vue?vue&type=script&lang=js&"
export * from "./studentExam_desktop.vue?vue&type=script&lang=js&"
import style0 from "./studentExam_desktop.vue?vue&type=style&index=0&id=7db7696d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db7696d",
  null
  
)

export default component.exports